// One journal's saves, one at a time (security sprint PR 12, review D1). While a save is in
// flight, newer drafts wait, and only the latest of them runs next; earlier ones are dropped,
// since each draft task reads the newest text when it runs. close() stops drafts for Publish:
// it drops the waiting one (Publish sends the newest text itself) and resolves when the one in
// flight is done. drain() is for leaving the page: no new drafts, but the waiting one still
// runs, so the newest text is saved.
export function createSaveQueue(onError = (err) => console.log('autosave failed: ', err)) {
  let running = null
  let next = null
  let closed = false
  let draining = false

  const pump = async () => {
    while (next && !closed) {
      const task = next
      next = null
      try {
        await task()
      } catch (err) {
        onError(err)
      }
    }
    running = null
  }

  return {
    draft(task) {
      if (closed || draining) return Promise.resolve()
      next = task
      if (!running) running = pump()
      return running
    },
    drain() {
      draining = true
      return running ?? Promise.resolve()
    },
    async close() {
      closed = true
      next = null
      if (running) await running
    },
    // After a failed Publish the page stays open, so drafts resume.
    reopen() {
      closed = false
    },
    get closed() {
      return closed || draining
    },
  }
}
